'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvVolumeDown = function AvVolumeDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z' })
  );
};
AvVolumeDown = (0, _pure2.default)(AvVolumeDown);
AvVolumeDown.displayName = 'AvVolumeDown';
AvVolumeDown.muiName = 'SvgIcon';

exports.default = AvVolumeDown;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/av/volume-down.js
 ** module id = 1715
 ** module chunks = 0
 **/